<template>
	<div>
		<v-snackbar v-model="checkinCreatedNotif" top>
			Check In Created. You can't edit the Check In unless you're the recipient.
			<v-btn color="pink" flat @click="checkinSavedNotif = false" timeout="6000">Close</v-btn>
		</v-snackbar>
		<v-snackbar v-model="checkinSavedNotif" top>
			Check In Saved
			<v-btn color="pink" flat @click="checkinSavedNotif = false" timeout="3000">Close</v-btn>
		</v-snackbar>
		<v-snackbar v-model="checkinFailedNotif" top color="error">
			Failed to save Check In.
			<v-btn dark flat @click="checkinFailedNotif = false" timeout="3000">Close</v-btn>
		</v-snackbar>

		<div v-if="checkIn">
			<check-in :checkIn="checkIn" :logged-in-employee="loggedInEmployee" :isSaving="isSaving" :isSubmitting="isSubmitting" @onCancel="onCancel" @save="onSave" />
		</div>
		<div v-else>
			This resource could not be found
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import CheckIn from '@/components/checkin/CheckIn';

	export default {
		name: 'PageCheckIn',
		props: {
			id: {
				required: true
			},
			justCreated: {
				type: Boolean,
				required: false
			}
		},
		components: {
			CheckIn
		},
		data() {
			return {
				checkinSavedNotif: false,
				checkinFailedNotif: false,
				checkinCreatedNotif: false,
				isSaving: false,
				isSubmitting: false
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
			checkIn() {
				return this.$store.state.checkIns.checkIns.find(x => x.id == this.id);
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', `Check In: ${this.checkIn.employee.fullName}`);
		},
		methods: {
			onCancel() {
				window.history.back();
			},
			async onSave(checkIn) {
				this.checkinSavedNotif = false;
				this.checkinFailedNotif = false;

				if(checkIn.signOff)
					this.isSubmitting = true;
				else
					this.isSaving = true;

				try {
					console.log('check in edited');
					var result = await this.$store.dispatch('checkIns/edit', checkIn);
					this.$router.push(`/checkIn/${result.id}`);
					this.checkinSavedNotif = true;
					this.isSaving = false;
					this.isSubmitting = false;
				} catch(err) {
					console.error('Error saving checkin');
					console.error(err);
					this.checkinFailedNotif = true;
					this.isSaving = false;
					this.isSubmitting = false;
				}
			},
		}
	};
</script>

<style></style>
